import history from 'history/browser';
import { AUTH_ACTIONS } from '../constants/action.constants';
import { AUTH_ERROR_PATH, LOGIN_PATH, ROOT_PATH } from '../constants/paths.constants';
import { AUTH_METHODS, BFF_HOST, EXPIRATION_DELAY, MAX_LOGIN_TIME } from '../constants/settings.constants';
import { USER_RESOURCE } from '../resources/user.resource';
import { users } from '../services/bff.api';
import {
  clearToken,
  getLoginMethod,
  getLoginTime,
  getRefreshToken,
  getToken,
  getTokenExpiration,
  storeRefreshToken,
  storeToken,
  storeTokenExpiration
} from '../services/session.storage';
import { apiActionCreator } from './api.actions';
import { fetchDone, fetchError, fetchStart } from './fetch.actions';

export function logBackIn() {
  clearToken();
  window.location = `${LOGIN_PATH}?fromUrl=${window.location.pathname}${window.location.search}`;
}

export function logout() {
  const token = getToken();
  if (token) {
    const host = BFF_HOST[process.env.REACT_APP_SPO_ENV] || '';
    const loginMethod = getLoginMethod();
    if (loginMethod === AUTH_METHODS.MPROFIEL) {
      window.location = `${host}/mprofiel/auth/logout/mprofiel?token=${token}`;
    } else {
      window.location = `${host}/aprofiel/auth/logout?token=${token.slice(2)}`;
    }
    history.push(ROOT_PATH);
  } else {
    history.push(LOGIN_PATH);
  }
}

export function fetchUser(onSuccess) {
  return (dispatch) => {
    dispatch(fetchStart(USER_RESOURCE));
    apiActionCreator(
      users.getCurrent,
      dispatch,
      (resp) => {
        // dispatch({ type: AUTH_ACTIONS.SUCCESS, data: { ...resp, permissions: [PERMISSIONS.STAD_ADMIN] } });
        dispatch({ type: AUTH_ACTIONS.SUCCESS, data: resp });
        dispatch(fetchDone(USER_RESOURCE));
        if (onSuccess) {
          onSuccess(resp);
        }
      },
      {
        all: () => {
          dispatch(fetchError(USER_RESOURCE));
          if (window.location.pathname !== AUTH_ERROR_PATH) {
            window.location = AUTH_ERROR_PATH;
          }
        }
      }
    );
  };
}

export function checkAuthExpiration() {
  return (dispatch) => {
    const token = getToken();
    if (!token) {
      return;
    }
    const loginTime = getLoginTime();
    console.log(`Login time = ${loginTime}`);
    console.log(`Now = ${Date.now()}`);
    if (Date.now() - loginTime > MAX_LOGIN_TIME) {
      return dispatch(logout());
    }
    const expiration = getTokenExpiration();
    console.log(`Token expiration = ${expiration}`);
    console.log(`Now = ${Date.now()}`);
    if (expiration && parseInt(expiration) - Date.now() < EXPIRATION_DELAY) {
      dispatch(refreshToken());
    }
  };
}

export function refreshToken() {
  return (dispatch) =>
    apiActionCreator(
      () => users.refreshToken(getRefreshToken(), getLoginMethod()),
      dispatch,
      (response) => {
        const loginMethod = getLoginMethod();
        const tokenPrefix = loginMethod === AUTH_METHODS.MPROFIEL ? 'm_' : 'a_';
        storeToken(`${tokenPrefix}${response.accessToken}`);
        storeRefreshToken(response.refreshToken);
        storeTokenExpiration(Date.now() + response.expiresIn * 1000);
      }
    );
}
